import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "LEDService",
  controller: "SendLog",
};

const methods = [
  "SendLog"
];

const factory = (Fun)=>{
    utils.extend(Fun.prototype, info)
    methods.forEach(path => {
        Fun.prototype[path] = function(data) {
            return this.post(path, data)
        }
    })
};

const SendLogApi = ZJApi.defineNewApi("SendLogApi", factory);

export default SendLogApi;
